import { render } from "./nazioni.vue?vue&type=template&id=73207ce3&ts=true"
import script from "./nazioni.vue?vue&type=script&lang=ts"
export * from "./nazioni.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__